"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTournamentsSaga = fetchTournamentsSaga;
exports.fetchTournamentsSagaV1 = fetchTournamentsSagaV1;
exports.fetchTournamentsSagaV2 = fetchTournamentsSagaV2;
const effects_1 = require("redux-saga/effects");
const selectors_1 = require("../../CommonDataProvider/selectors");
const saga_1 = require("../../ConfigProvider/saga");
const LanguagesProvider_1 = require("../../LanguagesProvider");
const errors_1 = require("../../../utils/errors");
const ConfigProvider_1 = require("../../ConfigProvider");
const api_1 = require("../../../api/tournaments/api");
const slice_1 = require("../slice");
const utils_1 = require("../utils");
function* fetchTournamentsSaga(action) {
    const { reqData, sideEffects: { onSuccess, onError } = {} } = action.payload;
    try {
        const isNewTournamentsEndpoint = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.NEW_TOURNAMENTS_ENDPOINT);
        const resData = isNewTournamentsEndpoint
            ? yield (0, effects_1.call)(fetchTournamentsSagaV2, reqData)
            : yield (0, effects_1.call)(fetchTournamentsSagaV1, reqData);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchTournamentsSuccess({ resData }));
        if (onSuccess) {
            yield (0, effects_1.put)(onSuccess({ reqData, resData }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching tournaments', error);
        yield (0, effects_1.put)(slice_1.eventsProviderActions.fetchTournamentsError(error));
        if (onError) {
            yield (0, effects_1.put)(onError(error));
        }
    }
}
function* fetchTournamentsSagaV1(data) {
    const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    const topTagId = yield (0, effects_1.select)(selectors_1.selectTopTagId);
    const currentLangCode = yield (0, effects_1.select)(LanguagesProvider_1.selectCurrentLangCode);
    const reqPayload = { locale: currentLangCode };
    const requestData = (0, utils_1.createTournamentsReq)(data, isGenericSportsEnabled, topTagId);
    const { data: resData } = yield (0, effects_1.call)(api_1.getTournaments, {
        ...requestData,
        ...reqPayload,
    });
    return resData;
}
function* fetchTournamentsSagaV2(data) {
    const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    const topTagId = yield (0, effects_1.select)(selectors_1.selectTopTagId);
    const currentLangCode = yield (0, effects_1.select)(LanguagesProvider_1.selectCurrentLangCode);
    let allItems = [];
    let paginationKey;
    while (true) {
        const request = (0, utils_1.createTournamentsReqV2)({ ...data, pageKey: paginationKey }, isGenericSportsEnabled, topTagId, currentLangCode);
        const response = yield (0, effects_1.call)(api_1.getTournamentsV2, request);
        allItems = [...allItems, ...response.data.items];
        if (!response.data.paginationKey) {
            break;
        }
        paginationKey = response.data.paginationKey;
    }
    return { items: allItems, paginationKey };
}
//# sourceMappingURL=fetchTournamentsSaga.js.map